import { Pipe, type PipeTransform } from '@angular/core';
import { Metadata } from '../models/data-result.model';

const URL_PLACEHOLDER = '${URL_OPPORTUNITY}';
@Pipe({
  name: 'appReplacePlaceholderWithUrl',
  standalone: true,
})
export class ReplacePlaceholderWithUrlPipe implements PipeTransform {
  transform(value: string, metadata: Metadata): string {
    if (!value || value.indexOf(URL_PLACEHOLDER) === -1) {
      return value;
    }

    const params = new URLSearchParams({
      URL_Preventivatore__c: `${window.location.origin}/dashboard?quoteId=${metadata.quoteId}`,
      Tipologia_Opportunit__c: 'Multi Cloud',
      Vendor__c: metadata.typology,
      Nome_servizio_a_catalogo__c: metadata.templateDriveName,
    }).toString();
    const url = `${window.location.origin}/opportunity?${params}`;
    return value.replace(URL_PLACEHOLDER, url);
  }
}
